module.exports = __webpack_public_path__ + "img/shiba-loadingๅ.7139b174.png";